import { Product } from "@/models/product.model"
import { storeToRefs } from "pinia"
import { ProductRepository } from "@/repositories/product-repository"
import type { IProduct } from "@/interfaces/api/product.interface"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { useProductsStore } from "@/store/products.store"

export class AppProductController extends GenericModelController<
  Product,
  IProduct,
  ProductRepository
> {
  constructor() {
    const productsStore = useProductsStore()
    const { appProducts } = storeToRefs(productsStore)
    const storeFunctionsConfig = {
      collection: appProducts,
      managed: false
    }

    super(Product, storeFunctionsConfig, new ProductRepository())
  }
}
